module.exports = __webpack_public_path__ + "assets/c15a6d153f64ddefbc098dc3c620a44d.mp3";